import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col, Card, Icon, Button, Input, Checkbox, message } from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import { Translate } from "react-translated";
import { TYPE_OF_CALL } from "../../utils/Constants";
import { ADD_ROLES_API, API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API, API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API, API_CHECK_BEFORE_REMOVE_ROLE_REVIEW_API, GET_ROLES_API, GET_ROLES_BY_USER_ID_API, REMOVE_ROLES_API } from "../../utils/Api_enums";

class EditUser extends Component {
  state = {
    loading: true,
    user: {},
    checkTypeOFCall: [],
    roles: [],
    roles_by_user_id: [],
    edit_user_type: ""
  };

  getRoles = async () => {
    const { data: { roles } } = await axios.get(GET_ROLES_API);
    const updatedRoles = roles.map(item => {
      return {
        label: TYPE_OF_CALL[item.rolename],
        value: item.role_id,
        checked: false
      }
    }).reverse();
    this.setState(prevState => ({
      ...prevState,
      roles: updatedRoles
    }))
  }
  getRolesbyUserId = async () => {
    const { data } = await axios.get(`${GET_ROLES_BY_USER_ID_API}/${this.props.match.params.user_id}`);
    if (data.error_response) {
      message.error(data.error_response)
      return
    }
    const roles = data.roles.map(item => item.role_id);
    const updatedRoles = this.state.roles.map(item => {
      return {
        label: item.label,
        value: item.value,
        checked: roles.includes(item.value)
      }
    })

    this.setState(prevState => ({
      ...prevState,
      roles: updatedRoles
    }))
  }


  getUserRole = () => {
    // Check conditions based on the call types array
    const rolesArr = this.state.roles.filter(role => role.checked === true).map(role => role.label);
    
    const hasReview = rolesArr.includes('Review');
    const hasLead = rolesArr.includes('Lead');
    const hasOpportunity = rolesArr.includes('Opportunity');

    // Define the roles based on the combinations of call types
    if (hasReview && !hasLead && !hasOpportunity) {
      return 'REVIEWSCHEDULER';
    } else if ((hasLead || hasOpportunity) && !hasReview) {
      // FS
      return 'VONBOARDER';
    } else if (hasReview && hasLead && !hasOpportunity) {
      return 'VONSCHEDULER';
    } else if (hasReview && !hasLead && hasOpportunity) {
      return 'VONSCHEDULER';
    } else if (hasReview && hasLead && hasOpportunity) {
      return 'VONSCHEDULER';
    }

    return '';
  }



  componentDidMount = async () => {
    this.setState({ loading: true });
    const { location } = this.props;
    const queryParams = new URLSearchParams(location.search);
    const edit_user_type = queryParams.get('edit_user_type');
    this.setState(prevState => ({
      ...prevState,
      edit_user_type: edit_user_type
    }))
    // fetch roles 
    await this.getRoles();
    // fetch roles by user id
    if (edit_user_type === "scheduler") {
      await this.getRolesbyUserId();
    }

    let user_id = 0;
    if (typeof this.props.match.params.user_id !== "undefined") {
      user_id = this.props.match.params.user_id;
    }
    axios.get("/api/users/" + user_id).then((res) => {
      this.setState({
        loading: false,
        user: res.data,
      });
    });
  };
  updateField = (name, val) => {
    const { user } = this.state;
    if (name === "jobs") {
      const data = { onboarding: false, life_licensed: false };
      if (val.indexOf("onboarding") >= 0) data.onboarding = true;
      if (val.indexOf("life_licensed") >= 0) data.life_licensed = true;
      val = JSON.stringify(data);
    }
    user[name] = val;
    this.setState({ user });
  };
  update = () => {
    // reset notification
    message.destroy();
    const { user } = this.state;
    let user_type = user.user_type;

    if (
      (user.first_name == null || user.first_name.trim().length === 0) &&
      (user.last_name == null || user.last_name.trim().length === 0) &&
      (user.email == null || user.email.trim().length === 0)
    ) {
      message.error("Please fill all the required fields");
      return false;
    }

    // validate first name
    if (user.first_name == null || user.first_name.trim().length === 0) {
      message.error("First Name is required.");
      return false;
    }

    // validate last name
    if (user.last_name == null || user.last_name.trim().length === 0) {
      message.error("Last Name is required.");
      return false;
    }

    // validate Email
    if (user.email == null || user.email.trim().length === 0) {
      message.error("Email is required.");
      return false;
    }

    // validate Email regex
    if (
      user.email != null &&
      user.email.trim().length > 0 &&
      !F.validateEmail(user.email)
    ) {
      message.error(F.translate(`Email is invalid.`));
      return false;
    }

    // validate Phone Number
    if (
      user.phone != null &&
      user.phone.trim().length > 0 &&
      !F.validatePhoneRegix(user.phone.trim())
    ) {
      message.error("Phone Number is Invalid");
      return false;
    }

    if (this.state.edit_user_type === "scheduler") {

      const uncheckedRoles = this.state.roles.filter(
        (item) => item.checked === false
      );
      const checkedRoles = this.state.roles.filter(
        (item) => item.checked === true
      );

      if (checkedRoles.length === 0) {
        message.error("Please select at least one type of call");
        return false;
      }

      // console.log("uncheckedRoles",uncheckedRoles)
      // console.log("checkedRoles",checkedRoles)

      axios.post(REMOVE_ROLES_API, {
        user_id: user.id,
        role_ids: uncheckedRoles.map(item => item.value)
      });

      if (checkedRoles.length > 0) {

        //  Type of Call for the Scheduler API CALL
        axios.post(ADD_ROLES_API, {
          user_id: user.id,
          role_ids: checkedRoles.map(item => item.value)
        });
      }

      this.setState({ loading: true });

      axios
        .put("/api/users/" + user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          phone:
            user.phone != null
              ? F.removeFormatterFromPhoneNumber(user.phone)
              : null,
          // company_name: user.company_name,
          address: user.address,
          city: user.city,
          state: user.state,
          zipcode: user.zipcode,
          jobs: user.jobs,
          user_type: this.getUserRole(),
        })
        .then((res) => {
          message.success(F.translate(`User Details Updated Successfully`));

          // as discussed abhi no needed now 
          // user_type = user.user_type === "REVIEWSCHEDULER" || "REVIEWADMIN" ? "REVIEWADMIN" : "";

          // //redirect to same page from where the edit is triggered
          // switch (user.user_type) {
          //   case "REVIEWSCHEDULER":
          //   case "REVIEWADMIN":
          //     user_type = "REVIEWADMIN"
          //     break
          //   case "VONBOARDER":
          //   case "BOBADMIN":
          //     user_type = "BOBADMIN"
          //     break
          //   default:
          //     user_type = "SUPER_ADMIN"
          // }
          this.setState({ loading: false }, () => {
            this.props.history.goBack()
            // this.props.history.push({
            //   pathname: '/manage-users',
            //   state: { user_type }
            // });
          });
        }).catch((err) => {
          message.error(err.response.data.error_response)
        }).finally(() => {
          this.setState((prevState) => ({
            ...prevState,
            loading: false
          }))
        })

    } else {
      //  not scheduler 
      this.setState({ loading: true });

      axios
        .put("/api/users/" + user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          phone:
            user.phone != null
              ? F.removeFormatterFromPhoneNumber(user.phone)
              : null,
          // company_name: user.company_name,
          address: user.address,
          city: user.city,
          state: user.state,
          zipcode: user.zipcode,
          jobs: user.jobs,
          // user_type:this.getUserRole(),
        })
        .then((res) => {
          message.success(F.translate(`User Details Updated Successfully`));

          // as discussed abhi no needed now 
          // user_type = user.user_type === "REVIEWSCHEDULER" || "REVIEWADMIN" ? "REVIEWADMIN" : "";

          // //redirect to same page from where the edit is triggered
          // switch (user.user_type) {
          //   case "REVIEWSCHEDULER":
          //   case "REVIEWADMIN":
          //     user_type = "REVIEWADMIN"
          //     break
          //   case "VONBOARDER":
          //   case "BOBADMIN":
          //     user_type = "BOBADMIN"
          //     break
          //   default:
          //     user_type = "SUPER_ADMIN"
          // }
          this.setState({ loading: false }, () => {
            this.props.history.goBack()
            // this.props.history.push({
            //   pathname: '/manage-users',
            //   state: { user_type }
            // });
          });
        }).catch((err) => {
          message.error(err.response.data.error_response)
        }).finally(() => {
          this.setState((prevState) => ({
            ...prevState,
            loading: false
          }))
        })

    }


  };


  checkforReview = async () => {
    try {
      const { data } = await axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_REVIEW_API}/${this.props.match.params.user_id}`);
      // console.log("res review",data)
      return data;
      // message.error(F.translate(`Select a link to schedule appointment.`));

    } catch (error) {
      console.log("error", error)
    }
  }
  checkforLead = async () => {
    try {
      const { data } = await axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API}/${this.props.match.params.user_id}?role_filter=Prospect`);
      // console.log("res Lead",res)
      return data
    } catch (error) {
      console.log("error", error)
    }
  }
  checkforOpportunity = async () => {
    try {
      const { data } = await axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API}/${this.props.match.params.user_id}?role_filter=FollowUp`);
      // console.log("res opportunity",res)
      return data
    } catch (error) {
      console.log("error", error)
    }
  }



  checkboxHandleChange = async (e) => {

    const { value, checked } = e.target;
    const checkedValues = JSON.parse(value);

    if (checkedValues.label === "Review" && checked === false) {

      const data = await this.checkforReview();
      if (data && data.success && data.unclick === false) {
        message.error(F.translate(data.message));
        return;
      }
    }
    if (checkedValues.label === "Lead" && checked === false) {
      const data = await this.checkforLead();
      if (data && data.success && data.unclick === false) {
        message.error(F.translate(data.message));
        return;
      }
    }
    if (checkedValues.label === "Opportunity" && checked === false) {
      const data = await this.checkforOpportunity();
      if (data && data.success && data.unclick === false) {
        message.error(F.translate(data.message));
        return;
      }
    }

    // else part for checkbox
    const updatedRoles = this.state.roles.map(item =>
      item.label === checkedValues.label && item.value === checkedValues.value
        ? { ...item, checked: checked }
        : item
    );
    this.setState(prevState => ({
      ...prevState,
      roles: updatedRoles
    }))

    // console.log("checkedValues",checkedValues)
    // console.log("handleCheckbox roles",this.state.roles)
    // const updatedRoles = this.state.roles.map(item => 
    //   item.label === checkedValues.label && item.value === checkedValues.value
    //     ? { ...item, checked: checked }  
    //     : item
    // );

    // console.log("updatedRoles",updatedRoles)
    // this.setState(prevState=>({
    //   ...prevState,
    //   roles:updatedRoles
    // }))
    //  console.log('checkedValues',checkedValues)
  }



  render() {
    const { loading, user } = this.state;
    const updateField = this.updateField;




    const uncheckedRoles = this.state.roles.filter(
      (item) => !this.state.checkTypeOFCall.includes(item.value)
    );

    const jobs = [];
    if (user.user_type === "LSP" && user.jobs !== "" && user.jobs !== null) {
      const jobs_json = JSON.parse(user.jobs);
      if (jobs_json.onboarding) {
        jobs.push("onboarding");
      }
      if (jobs_json.life_licensed) {
        jobs.push("life_licensed");
      }
    }
    return (
      <div>
        <Card
          type="inner"
          title={
            <span>
              <Icon type="user" style={{ marginRight: 8 }} />
              <Translate text={`Edit User`} />
            </span>
          }
          loading={loading}
        >
          {user.user_type === "LSP" ? (
            <div>
              <Row gutter={16}>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`First Name`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.first_name}
                      onChange={(e) =>
                        updateField("first_name", e.target.value)
                      }
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Last Name`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.last_name}
                      onChange={(e) => updateField("last_name", e.target.value)}
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Email`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.email}
                      onChange={(e) => updateField("email", e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              {/* <h3>
                    <Translate text={`Select Jobs`} />
                </h3>
                <Checkbox.Group
                    value={jobs}
                    style={{ width: "100%" }}
                    onChange={(checkedList) => updateField("jobs", checkedList)}
                >
                    <Checkbox value="onboarding">
                    <Translate text={`Onboarding`} />
                    </Checkbox>
                    <Checkbox value="life_licensed">
                    <Translate text={`Life Licensed`} />
                    </Checkbox>
                </Checkbox.Group> */}
            </div>
          ) : (
            <div>
              <Row gutter={16}>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`First Name`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.first_name}
                      onChange={(e) =>
                        updateField("first_name", e.target.value)
                      }
                      maxLength={50}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Last Name`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.last_name}
                      onChange={(e) => updateField("last_name", e.target.value)}
                      maxLength={50}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Email`} />
                      <span className="asteriskIcon">*</span>
                    </label>
                    <Input
                      value={user.email}
                      onChange={(e) => updateField("email", e.target.value)}
                    />
                  </div>
                </Col>
                <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Phone`} />
                    </label>
                    <Input
                      value={F.phone_format(user.phone)}
                      onChange={(e) => {
                        if (e.target.value.trim().length <= 14) {
                          const updateNumber = F.phone_format(e.target.value);
                          updateField("phone", updateNumber);
                        }
                      }}
                    />
                  </div>
                </Col>
                {/* <Col md={8} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Company Name`} />:
                    </label>
                    <Input
                      value={user.company_name}
                      onChange={(e) =>
                        updateField("company_name", e.target.value)
                      }
                    />
                  </div>
                </Col> */}
              </Row>
              <Row gutter={16}>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Address`} />
                    </label>
                    <Input
                      value={user.address}
                      onChange={(e) => updateField("address", e.target.value)}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`City`} />
                    </label>
                    <Input
                      value={user.city}
                      onChange={(e) => updateField("city", e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`State`} />
                    </label>
                    <Input
                      value={user.state}
                      onChange={(e) => updateField("state", e.target.value)}
                    />
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="inputField">
                    <label>
                      <Translate text={`Zipcode`} />
                    </label>
                    <Input
                      value={user.zipcode}
                      onChange={(e) => updateField("zipcode", e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              {this.state.edit_user_type === "scheduler" && (<Row gutter={16}>
                <Col md={16} span={24}>
                  <div className="inputField" >
                    <label style={{
                      display: "block",
                      //  padding: "10px 0px"
                    }} ><Translate text={`Select Type of Call for the Scheduler `} />                       <span className="asteriskIcon">*</span>
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "60%"
                    }}
                  >
                    {/* {    console.log('checkTypeOFCall = ', this.state.checkTypeOFCall)               } */}
                    {/* <Checkbox.Group
                              className='invite-scheduler-checkboxes'
                              style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "60%"
                              }}
                            options={this.state.roles}
                            value={this.state.checkTypeOFCall} 
                            onChange={this.checkboxHandleChange} /> */}

                    {
                      this.state.roles.map((role) => {
                        return (
                          <Checkbox
                            key={role.role_id}
                            value={JSON.stringify(role)}
                            checked={role.checked}
                            onChange={this.checkboxHandleChange}
                          >
                            {role.label}
                          </Checkbox>
                        )
                      })
                    }

                  </div>
                </Col>
              </Row>)}
            </div>
          )}
          <div className="right-align">
            <Button type="primary"
              className="bg-164897 borderRadius-28"
              onClick={this.update.bind(this)}>
              <Translate text={`Edit User`} />
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export default withRouter(EditUser);



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/edit.js